import en from '@/assets/i18n/en.json';
import es from '@/assets/i18n/es.json';
import fr from '@/assets/i18n/fr.json';
import it from '@/assets/i18n/it.json';
import de from '@/assets/i18n/de.json';
import kr from '@/assets/i18n/kr.json';
import jp from '@/assets/i18n/jp.json';
import chs from '@/assets/i18n/chs.json';

const t = {
  en,
  it,
  es,
  fr,
  de,
  kr,
  ko: kr,
  jp,
  ja: jp,
  'zh-Hans': chs,
  zh: chs,
};

const translate = (key, lang) => t[lang] ? t[lang][key] : 'NO_LANG'; // eslint-disable-line

export default translate;
